export const BATCH_THROTTLE_DURATION_MS = 300;
export const EXTRA_BASE_PARAMS = ['dataCenter', 'isCached', 'isRollout', 'isHeadless'];
//# sourceMappingURL=constants.js.map